import React from "react";

const Color = () => {
  return <div></div>;
};

export default Color;
